// extracted by mini-css-extract-plugin
module.exports = {"container":"Verification_container__2uqre","status":"Verification_status__TAGUp","field":"Verification_field__q9syQ"};